/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLightbulbEdit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12.003 2a6.77 6.77 0 0 1 2.343.42l-.693 1.875A4.762 4.762 0 0 0 12.003 4h-.05l-.242.012c-2.49.19-4.583 2.34-4.706 5.024a5.158 5.158 0 0 0 1.445 3.848A5.604 5.604 0 0 1 9.74 15H11v-4h2v4h1.242a4.737 4.737 0 0 1 1.272-2.072c.402-.393.724-.854.965-1.358l1.805.861a6.77 6.77 0 0 1-1.386 1.941l-.006.006-.006.005c-.587.555-.884 1.36-.884 2.229V17H16v1a4 4 0 0 1-8 0v-1.554c-.043-.76-.377-1.538-.99-2.174a7.158 7.158 0 0 1-2.004-5.326v-.002C5.18 5.182 8.202 2.092 11.903 2zM10 18a2 2 0 0 0 4 0v-1h-4z" />
        <path d="M19.053.544a1.5 1.5 0 0 1 2.007.103l2.293 2.293a1.5 1.5 0 0 1 0 2.12L18.413 10H14V5.586l4.94-4.94zM16 6.414V8h1.586l4-4L20 2.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgLightbulbEdit as LightbulbEdit };
